import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { IPromotionalCodeDiscount } from '../../../../slices/upgradeAccount/promotionalCode/interfaces';
import { ISubscriptionPrices } from '../../../../slices/upgradeAccount/subscriptionPrices/interfaces';
import { CadenceTypesValues } from '../../../auth/proRegister/subscriptionTypes';

export const formatPriceAmount = (price: number): string => {
  const parsedPrice = `${price}`;
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return parsedPrice;
  }
  if (!Number.isInteger(price)) {
    return price.toFixed(2);
  }
  return parsedPrice;
};

export const getDiscountedPrice = (price: number, discount?: IPromotionalCodeDiscount ): string => {
  if (!isFeatureEnabled(Features.PromotionalCodes) || !discount) {
    return formatPriceAmount(price);
  }
  let amount = 0;
  if (discount?.amountOffInCents) {
    amount = discount.amountOffInCents / 100;
  }
  if (discount?.percentOff) {
    amount = price * (discount.percentOff / 100);
  }
  return formatPriceAmount(price - amount);
};

export const getPriceByCadence = (cadence: CadenceTypesValues, prices?: ISubscriptionPrices): number => {
  if (!prices || !isFeatureEnabled(Features.PromotionalCodes)) {
    return 0;
  }
  switch(cadence) {
  case CadenceTypesValues.ANNUALLY:
    return prices.annualPrice / 100;
  case CadenceTypesValues.MONTHLY:
    return prices.monthlyPrice / 100;
  }
};